import React from "react";
import {Alert, Badge, Card, Form} from "react-bootstrap";
import ValidationHelper from "../../../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../../../../components/dialogs/baseDialog/BaseDialog";
import QrCodeScanner from "../../../../../../components/qrCodeScanner/QrCodeScanner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLaptop} from "@fortawesome/free-solid-svg-icons";

class CreateReplacementDevice extends React.Component {
    constructor(props) {
        super(props);

        this.validationDefinition = {
            identifier: {
                defaultValue: "",
                rule: ValidationHelper.isString
            },
            serial: {
                defaultValue: "",
                rule: ValidationHelper.isString
            },
            name: {
                defaultValue: "",
                rule: ValidationHelper.isString
            },
            challenge: {
                defaultValue: "",
                rule: ValidationHelper.isChallenge
            }
        };

        this.state = {
            validation: ValidationHelper.getValidation(this.validationDefinition),
            scannerIsRunning: false,
            stagedDevice: null
        };

        this.handleChange = this.handleChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onHide = this.onHide.bind(this);
        this.handleScanResult = this.handleScanResult.bind(this);
        this.handleScanValidation = this.handleScanValidation.bind(this);
        this.handleScanStart = this.handleScanStart.bind(this);

        this.scannerRef = React.createRef();
    }

    handleChange(event) {
        this.setState({
            validation: ValidationHelper.update(event, this.state.validation)
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.show !== this.props.show) {
            this.setState({
                validation: ValidationHelper.getValidation(this.validationDefinition)
            });
        }
    }

    handleScanStart(callback) {
        this.setState({ scannerIsRunning: true, stagedDevice: null }, callback);
    }

    handleScanResult(res) {
        this.setState({ scannerIsRunning: false });
        const device = JSON.parse(res);
        this.handleChange({ target: { name: "serial", value: device.t.serial } });
        this.handleChange({ target: { name: "name", value: device.t.name } });
        this.handleChange({ target: { name: "challenge", value: { id: device.t.id, token: device.t.token} } });
        if (this.state.validation.challenge.isValid){
            this.setState({ stagedDevice: device });
        }
    }


    handleScanValidation(res){
        try {
            const device = JSON.parse(res);
            return typeof device["i"] !== "undefined"
                && typeof device["s"] !== "undefined"
                && typeof device["t"] !== "undefined"
        }catch (err){}
        return false;
    }

    onHide() {
        this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
    }

    onSubmit() {
        if (this.state.validation._isValid) {
            const validatedData = ValidationHelper.getData(this.state.validation);
            this.props.onSubmit(validatedData);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <BaseDialog
                show={this.props.show}
                onHide={this.onHide}
                rightButtonCallback={this.onSubmit}
                title={t("Hardware.Tabs.ReplacementDevices.Modal.Create.Title")}
                rightButtonText={t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.Create")}
                leftButtonText={t("DialogCancel")}
                rightButtonVariant="green"
                leftButtonVariant="black"
                leftButtonCallback={this.onHide}
                dialogApiError={this.props.dialogApiError}
                rightButtonDisabled={!this.state.validation._isValid}
                body={(<Form onSubmit={this.onSubmit}>
                        <Card>
                            <Card.Body>
                                <div className="pb-3">
                                    {this.state.stagedDevice ? (
                                        <>
                                            <Alert variant="success">
                                                {t("Hardware.Tabs.ReplacementDevices.Modal.Create.ValidChallenge")}
                                            </Alert>
                                            <Card className="mb-3">
                                                <Card.Body>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <Badge><FontAwesomeIcon icon={faLaptop} className="mr-1" /></Badge>
                                                            </td>
                                                            <td>
                                                                {this.state.stagedDevice.t.name}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td>
                                                                <i style={{fontSize: "8pt"}}>
                                                                    {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.Serial")}: {this.state.stagedDevice.t.serial}
                                                                </i>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </Card.Body>
                                            </Card>
                                        </>
                                    ) : <Alert variant="info">
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.InvalidChallenge")}
                                    </Alert>}
                                    <QrCodeScanner
                                        content={<span>{t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.RegisterDevice")}</span>}
                                        previewRef={this.scannerRef}
                                        validator={this.handleScanValidation}
                                        onScannerStart={this.handleScanStart}
                                        onScannerStop={() => {}}
                                        onScannerError={() => {}}
                                        onScannerResult={this.handleScanResult} />
                                </div>
                                <div style={{width: "100%", textAlign: "center"}}>
                                    {this.state.scannerIsRunning ? (
                                        <video ref={this.scannerRef} width={465} />
                                    ) : ""}
                                </div>
                                <Form.Group controlId="formIdentifier">
                                    <Form.Label>
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.Identifier")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="identifier"
                                        placeholder={t(
                                            "Hardware.Tabs.ReplacementDevices.Modal.Create.Form.IdentifierPlaceholder"
                                        )}
                                        value={this.state.validation.identifier.value}
                                        isInvalid={!this.state.validation.identifier.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.ValidationError.Identifier")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formName">
                                    <Form.Label>
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.Name")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder={t(
                                            "Hardware.Tabs.ReplacementDevices.Modal.Create.Form.NamePlaceholder"
                                        )}
                                        value={this.state.validation.name.value}
                                        isInvalid={!this.state.validation.name.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.ValidationError.Name")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formSerial">
                                    <Form.Label>
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.Serial")}
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="serial"
                                        placeholder={t(
                                            "Hardware.Tabs.ReplacementDevices.Modal.Create.Form.SerialPlaceholder"
                                        )}
                                        value={this.state.validation.serial.value}
                                        isInvalid={!this.state.validation.serial.isValid}
                                        onChange={this.handleChange}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {t("Hardware.Tabs.ReplacementDevices.Modal.Create.Form.ValidationError.Serial")}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Card.Body>
                        </Card>
                </Form>)}
            />
        );
    }
}

export default withTranslation()(CreateReplacementDevice);
